import { useFragment } from "react-relay"
import { AppointmentAttachment } from "@/modules/patients/components/attachments/attachment-item"
import { AppointmentAttachmentFragment$key } from "@/modules/waiting-room/services/__generated__/AppointmentAttachmentFragment.graphql"
import { AppointmentAttachmentFragment } from "@/modules/waiting-room/services/AppointmentAttachmentFragment"
import { SofiaEnvironment } from "@/sofia-environment"
import { FileUploadSource } from "@/types/__generated__/union-types"

const useAppointmentAttachments = ({
  uploadSources,
  appointmentAttachments,
}: {
  uploadSources: Array<FileUploadSource>
  appointmentAttachments: AppointmentAttachmentFragment$key
}) => {
  const appointmentAttachmentsFragment = useFragment<AppointmentAttachmentFragment$key>(
    AppointmentAttachmentFragment,
    appointmentAttachments,
  )

  const attachments: AppointmentAttachment[] = []

  const filteredAttachments = appointmentAttachmentsFragment
    ?.filter((attachment) => uploadSources.includes(attachment.uploadSource))
    .map((attachment) => {
      return {
        ...attachment,
        url: `${SofiaEnvironment.Bff.Url}/${attachment.url}`,
        thumbnailUrl: attachment.thumbnailUrl ? `${SofiaEnvironment.Bff.Url}/${attachment.thumbnailUrl}` : null,
      }
    })

  if (filteredAttachments && filteredAttachments.length > 0) attachments.push(...filteredAttachments)

  return attachments
}

export { useAppointmentAttachments }
